module.exports = __webpack_public_path__ + "static/img/oilApplication3.dc5592bd.png";